import React from 'react'
import { useStaticQuery, graphql, Link, withPrefix } from "gatsby"
import {Img} from 'react-image'

import arrow from "../images/arrow.svg"
import docImage from "../images/doc.svg"

import sectionSummaryStyles from "./SectionSummary.module.css"

export default function SectionSummary({ title, section, featuredPost, maxPosts = 3, postsTitles = true }) {

    const queryData = useStaticQuery(graphql`
        query {
            allMdx(sort: {fields: frontmatter___weight, order: DESC}) {
                edges {
                  node {
                    id
                    frontmatter {
                      post_title
                      dir
                      weight
                    }
                    fields {
                      slug
                    }
                    excerpt(pruneLength: 210)
                  }
                }
              }
        }
    `)        


    // get nodes related to provided section
    let sectionNodes = queryData.allMdx.edges.filter( ({node}) => node.fields.slug.startsWith(`/${section}/`));
    // make sure we don't include the post that represent the section itself
    sectionNodes = sectionNodes.filter( ({node}) => node.fields.slug !== `/${section}/`);

    // filter down level nodes
    // section  /tutorials/storage/
    // keep     /tutorials/storage/qencode-storage/
    // remove   /tutorials/storage/qencode-storage/bucket-limits/
    sectionNodes = sectionNodes.filter( ({node}) => node.fields.slug.replace(`${section}/`,'').split('/').length-1 === 2);

    // remove featured post from posts list
    // section = 'tutorials/transcoding'
    // featuredPost = 'launch-a-job'
    if(featuredPost){
        sectionNodes = sectionNodes.filter( ({node}) => node.fields.slug !== `/${section}/${featuredPost}/`);
    }

    const sectionPosts = sectionNodes.map( ({ node }) => {
        let icon = node.fields.slug.slice(0, -1) + '.svg'
        let lettersInPostSummary = 40
        if(!postsTitles){   
            lettersInPostSummary = 65
        }        
        let excerpt = node.excerpt.slice(0, lettersInPostSummary).trim().replace(/,\s*$/, "") + '...'
        
        return {
            title: node.frontmatter.post_title, 
            icon: icon,
            summary: excerpt,
            url: node.fields.slug
        }
    })

    if(maxPosts === 'max'){
        maxPosts = sectionPosts.length
    }


    const sectionPostsComponent = sectionPosts.slice(0, maxPosts).map( (post, index) => 
        <Link to={post.url} key={index} className={sectionSummaryStyles.postBlock} >
            <div className={sectionSummaryStyles.postBlock__image}>
                {/* <img src={withPrefix(`/images/docs/${post.icon}`)} alt={post.title} /> */}
                <Img
                    src={[withPrefix(`/images/docs/${post.icon}`), docImage]}
                    alt={post.title}
                />                
            </div>
            <div>
                {postsTitles && <h4>{post.title}</h4>}                  
                <p>{post.summary}</p>
            </div>
        </Link>
    )

    const FeaturedPostComponent = () => {    

        let featuredImageUrl = ''
        let featuredPostIconUrl = ''
        let featuredNodeUrl = ''
        if(featuredPost === section){
            featuredImageUrl = `${section}/index__featured.png`
            featuredPostIconUrl = `${section}/index.svg`
            featuredNodeUrl = section
        }else{
            featuredImageUrl = `${section}/${featuredPost}__featured.png`
            featuredPostIconUrl = `${section}/${featuredPost}.svg`
            featuredNodeUrl = `${section}/${featuredPost}`
        }
    

        // get featured page that matches slug exactly
        const featuredNode = queryData.allMdx.edges.filter( ({node}) => node.fields.slug === `/${featuredNodeUrl}/` )[0];
    
        // get other nodes from api reference section
        const featuredPage = {
            title: featuredNode.node.frontmatter.post_title,
            summary: featuredNode.node.excerpt
        }

        return (
            <Link to={`/${featuredNodeUrl}/`}>
                <div className={sectionSummaryStyles.summaryLinkBlock} >
                    <div className={sectionSummaryStyles.summaryCard} >
                        <div className={sectionSummaryStyles.icon}>
                            <img src={withPrefix(`/images/docs/${featuredPostIconUrl}`)} alt={featuredPage.title} />
                        </div>        
                        <div>                            
                            <h4>{featuredPage.title}</h4>
                            <p>{featuredPage.summary}</p>
                        </div>
                    </div>
                    <div className={sectionSummaryStyles.featuredImage}>
                        <img src={withPrefix(`/images/docs/${featuredImageUrl}`)} alt={featuredPage.summary.slice(0, 25).trim().replace(/,\s*$/, "") + '...'} />
                    </div>
                </div>
            </Link>
        )
    }    
   
    const AllPostsLinkComponent = () => {    
        return (
            <Link to={`/${section}/`} className={sectionSummaryStyles.allPostsLink}>View all <img src={arrow} alt="View all" /> </Link>
        )
    }

    return(
        <section className={sectionSummaryStyles.container}>            
            {title && <h2>{title}</h2>}   
            {sectionNodes.length > 3 && maxPosts !== sectionPosts.length && <AllPostsLinkComponent />}
            {featuredPost && <FeaturedPostComponent />}            
            <div className={sectionSummaryStyles.postsList}>
                {sectionPostsComponent}
            </div>
        </section>
    )
}
